module.exports = __webpack_public_path__ + "static/img/p-s4-2.4590b42b.png";